<template>
  <div
    class="ll-editable-question-list"
    :class="{'mt-sm':isMtSm}"
  >
    <div class="ll-editable-question-list_title-wrap">
      <p class="question-title">
        {{ title }}
      </p>
      <WsButton001
        v-if="!isSorting"
        out-line
        medium-button
        flat-button
        @click="$_sortingStart()"
      >
        {{ $t('排序') }}
      </WsButton001>
      <div
        v-if="isSorting"
        class="save-tools"
      >
        <WsButton001
          out-line
          short-button
          flat-button
          @click="$_sortingComplete()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          primary
          flat-button
          short-button
          @click="$_sortingSave()"
        >
          {{ $t('送出') }}
        </WsButton001>
      </div>
    </div>
    <div
      v-if="isSorting"
      class="ll-editable-question-list_list-wrap"
    >
      <div
        v-for="(list,questionListIndex) in sortingQuesList"
        :key="questionListIndex"
        class="ll-editable-question-list_sort-list"
      >
        <p class="ll-editable-question-list_subtitle">
          {{ list.title }}
        </p>
        <div class="ll-editable-question-list_list">
          <SlickList v-model="list.questionList">
            <SlickItem
              v-for="(sortingItem,sortingIndex) in list.questionList"
              :key="sortingIndex"
              class="list-item"
              :index="sortingIndex"
            >
              <SortingChecklistQuestion
                :title="sortingItem.title"
                :ques-num="sortingIndex+1"
                :subtitle="sortingItem.subtitle"
              />
            </SlickItem>
          </SlickList>
        </div>
      </div>
    </div>
    <div
      v-else
      class="ll-editable-question-list_list-wrap"
    >
      <div
        v-for="(list,questionListIndex) in C_questionList"
        :key="questionListIndex"
        class="ll-editable-question-list_list"
      >
        <p class="ll-editable-question-list_subtitle">
          {{ list.title }}
        </p>
        <div class="ll-editable-question-list_list">
          <div
            v-for="(ques,quesIndex) in list.questionList"
            :key="quesIndex"
            class="ll-editable-question-list_list-item"
          >
            <EditableChecklistQuestion
              v-if="ques.type ==='custom'"
              ref="EditableChecklistQuestion"
              v-model="list.questionList[quesIndex]"
              :ocap-edit="ocapEdit"
              :ques-num="quesIndex + 1"
              editable
              :editable-ques-type="editableQuesType"
              :text-label="textLabel"
              :attach-title="attachTitle"
              :upload-file-url="uploadAttachUrl"
              :upload-file-ocap-url="uploadFileOcapUrl"
              :chapter-num="chapterNum"
              :section-num="questionListIndex"
              :radio-name="$_getRadioNameByQuestionList(radioName,questionListIndex,quesIndex)"
              :type-radio-name="$_getRadioNameByQuestionList(typeRadioName,questionListIndex,quesIndex)"
              :factory="factoryId"
              :copy-drop-down="copyDropDown"
              @delete="$_deleteQuesPopupOpen(list.questionList,quesIndex)"
              @copy-click="$_copyClick(list.questionList,ques)"
            />
            <ChecklistQuestion
              v-if="ques.type === 'template'"
              ref="ChecklistQuestion"
              select
              annex
              change-ques-type
              :ocap-edit="ocapEdit"
              content-icon="icon-light"
              :ques-type="ques.quesType"
              :title="ques.title"
              :warning-text="ques.warningText"
              :subtitle="ques.subtitle"
              :remark="ques.remark"
              :attaches="ques.attaches"
              :ocap-remark="ques.ocapRemark"
              :ocap-attaches="ques.ocapAttaches"
              :upload-file-ocap-url="uploadFileOcapUrl"
              :articles="ques.articles"
              :ques-num="quesIndex + 1"
              :text-label="textLabel"
              :focus="ques.focus"
              :control-limit-data="ques.controlLimitData"
              :spec-limit-data="ques.specLimitData"
              :radio-name="$_getRadioNameByQuestionList(radioName,questionListIndex,quesIndex)"
              :risk-signal="ques.riskSignal"
              :required="$_rules(ques.id)"
              @law-click="$_lawClick($event)"
              @input="$_focusChange($event,ques)"
              @ocap-change="$_ocapFileChange($event,ques)"
              @ocap-delete="$_ocapFileDelete($event,ques)"
              @ocap-remark="$_ocapRemark($event,ques)"
            >
              <template v-slot:select>
                <StateSwitchCheckbox
                  :value="selectTemplateList"
                  :qustion-id="ques.id ? ques.id : ques.templateId"
                  @input="$_questionSelect($event)"
                />
                <WsTextButton001
                  leading-icon="icon-copy"
                  primary
                  font-size-xs
                  no-padding
                  @click="$_copyClick(list.questionList,ques)"
                >
                  {{ $t('複製') }}
                </WsTextButton001>
              </template>
            </ChecklistQuestion>
            <ChecklistQuestion
              v-if="ques.type === 'remove'"
              nodrop-down-toggle
              remove-style
              :title="ques.title"
              :subtitle="$t('題目在此公版已移除')"
            />
          </div>
          <WsButton001 @click="$_addQuestionClick(questionListIndex)">
            {{ $t('新增自訂題目') }}
          </WsButton001>
        </div>
      </div>
    </div>
    <PopUp
      :pop-up-active="deleteQuesPopupActive"
      :title="$t('確定捨棄嗎？')"
      @click="$_deleteQuesPopupClose()"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            out-line
            @click="$_deleteQuesPopupClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_deleteQuestion(deleteQuesList, deleteQuesIndex)">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <LlActPopup
      v-if="lawPopupActive"
      :is-loading="lawContentLoading"
      :law-content="lawContent"
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
    <LlActPopup
      v-else
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
  </div>
</template>
<script>
import { SlickList, SlickItem } from "vue-slicksort";
export default {
  name: "LlEditableQuestionList",
  components: {
    SlickList,
    SlickItem,
  },
  props: {
    lawContentLoading: {
      type: Boolean,
      default: false,
    },
    ocapEdit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editableQuesType: {
      type: Boolean,
      default: false,
    },
    selectTemplateList: {
      type: Array,
      default() {
        return [];
      },
    },
    questionList: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadImageUrl: {
      type: String,
      default: "",
    },
    uploadAttachUrl: {
      type: String,
      default: "",
    },
    uploadFileOcapUrl: {
      type: String,
      default: "",
    },
    factoryId: {
      type: String,
    },
    chapterNum: {
      type: Number,
      default: 0,
    },
    isMtSm: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default() {
        return this.$t("合規標準");
      },
    },
    attachTitle: {
      type: String,
      default() {
        return this.$t("附件");
      },
    },
    radioName: {
      type: String,
      default: "",
    },
    typeRadioName: {
      type: String,
      default: "",
    },
    lawContent: {
      type: Object,
      default() {
        return {};
      },
    },
    copyDropDown: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSorting: false,
    sortingQuesList: [],
    C_questionList: [],
    deleteQuesPopupActive: false,
    lawPopupActive: false,
    deleteQuesList: [],
    deleteQuesIndex: 0,
  }),
  watch: {
    questionList: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.C_questionList = newValue;
      },
    },
    C_questionList: {
      deep: true,
      handler() {
        this.$emit("question-edit", this.C_questionList);
      },
    },
    isSorting: {
      deep: true,
      handler() {
        this.$emit("sorting-active", this.isSorting);
      },
    },
  },
  methods: {
    $_rules(questionId) {
      if (!this.selectTemplateList.includes(questionId)) {
        return false;
      } else {
        return true;
      }
    },
    $_getRadioNameByQuestionList(radioName, questionListIndex, quesIndex) {
      return `${radioName}-${questionListIndex}-${quesIndex}`;
    },
    $_focusChange($event, ques) {
      ques.focus = $event;
      this.$emit("focus-change", $event);
    },
    $_ocapFileChange($event, ques) {
      ques.ocapAttaches = $event;
    },
    $_ocapFileDelete(index, ques) {
      ques.ocapAttaches.splice(index, 1);
    },
    $_ocapRemark($event, ques) {
      ques.ocapRemark = $event;
    },
    $_deleteQuesPopupOpen(questionList, index) {
      this.deleteQuesPopupActive = true;
      this.deleteQuesList = questionList;
      this.deleteQuesIndex = index;
    },
    $_deleteQuesPopupClose() {
      this.deleteQuesPopupActive = false;
      this.deleteQuesList = [];
      this.deleteQuesIndex = 0;
    },
    $_lawClick($event) {
      this.lawPopupActive = true;
      this.$emit("law-click", $event);
    },
    $_lawPopupClose() {
      this.lawPopupActive = false;
    },
    $_sortingStart() {
      this.isSorting = true;
      this.sortingQuesList = JSON.parse(JSON.stringify(this.C_questionList));
    },
    $_sortingSave() {
      this.C_questionList = this.sortingQuesList;
      this.$_sortingComplete();
    },
    $_sortingComplete() {
      this.isSorting = false;
    },
    $_deleteQuestion(questionList, index) {
      questionList.splice(index, 1);
      this.$emit("delete-click", questionList);
      this.$_deleteQuesPopupClose();
    },
    $_addQuestionClick($event) {
      this.$emit("add-click", $event);
    },
    $_copyClick(questionList, ques) {
      let copyQues = JSON.parse(JSON.stringify(ques));
      copyQues.title = `${copyQues.title}-${this.$t("複製")}`;
      questionList.push({
        title: copyQues.title,
        type: "custom",
        subtitle: this.$t("自訂題目"),
        attaches: ques.attaches,
        remark: ques.remark,
        ocapAttaches: ques.ocapAttaches,
        ocapRemark: ques.ocapRemark,
        quesType: ques.quesType,
        controlLimitData: ques.controlLimitData,
        specLimitData: ques.specLimitData,
        focus: ques.focus,
      });
    },
    $_questionSelect($event) {
      this.$emit("question-select", $event);
    },
    async $_submitClick() {
      if (this.$refs.EditableChecklistQuestion) {
        for (let i = 0; i < this.$refs.EditableChecklistQuestion.length; i++) {
          await this.$refs.EditableChecklistQuestion[i].$_submitClick();
        }
      }
      if (this.$refs.ChecklistQuestion) {
        for (let i = 0; i < this.$refs.ChecklistQuestion.length; i++) {
          await this.$refs.ChecklistQuestion[i].$_submitClick();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-editable-question-list";
</style>